// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

import { createSelector } from 'reselect';
import type { RootState } from 'Store';

// Reads for the Khora dashboard feature, hoisted out of inline useAppSelector arrows so the
// components stay render-only (mirrors Features/order/orderSelectors).

export const getChatbotOpen = (state: RootState) => state.dashboard.chatbotOpen;
export const getPinnedWidgets = (state: RootState) => state.dashboard.pinnedWidgets;
export const getPinnedCharts = (state: RootState) => state.dashboard.pinnedCharts;
export const getFeatureAnalysis = (state: RootState) => state.dashboard.featureAnalysis;
export const getLoadedGdbId = (state: RootState) => state.dashboard.loadedGdbId;

// Cross-slice reads the dashboard depends on (order/ selectors likewise read project/bundle state).
export const getViewerLayers = (state: RootState) => state.viewerLayers.layers;
// map.editor is wrapped by redux-undo (undoable), which widens its inferred type to `unknown`; the
// defensive optional-chain cast reads orderSelected without a spurious tsc error (same as callers do).
export const getSelectedOrderId = (state: RootState): string | null =>
  (state as { map?: { editor?: { present?: { orderSelected?: string | null } } } })
    .map?.editor?.present?.orderSelected ?? null;

// Layers whose per-feature analysis the user pinned to the dashboard ([layerName, analysis] pairs) —
// the "Popup Analyses" list, and the same set injected into each feature's popup.
export const getPopupAnalyses = createSelector(
  [getFeatureAnalysis],
  (featureAnalysis) => Object.entries(featureAnalysis).filter(([, analysis]) => analysis.onDashboard),
);
